import useSWR from 'swr';

import { levelsService } from 'v2/api/levelsService';
import { userProfileService } from 'v2/api/userProfileService';
import { userService } from 'v2/api/userService';
import { Nullable } from 'v2/types';
import { LevelModel } from 'v2/types/LevelModel';
import { UserModel } from 'v2/types/UserModel';
import {
  FavoriteSlotDto,
  TournamentBalanceDto,
  UserActiveTicketsDto,
  UserFingerprintDto,
  UserStatisticDto,
} from 'v2/types/UserProfileModel';
import { VipLevelModel } from 'v2/types/VipLevelModel';

interface UseUserProfileDataReturn {
  user: UserModel | undefined;
  stats: UserStatisticDto | undefined;
  fingerprints: UserFingerprintDto[] | undefined;
  balance: Nullable<TournamentBalanceDto> | undefined;
  activeTickets: UserActiveTicketsDto | undefined;
  slots: FavoriteSlotDto[] | undefined;
  inviter: UserModel | undefined;
  vipLevels: VipLevelModel[] | undefined;
  levels: LevelModel[] | undefined;
  isLoading: boolean;
}

export function useUserProfileData(userId: string): UseUserProfileDataReturn {
  const { data: user, isLoading: isLoadingUser } = useSWR(['getUser', userId], userService.getUser);

  const { data: stats, isLoading: isLoadingStats } = useSWR(
    ['getUserStatistic', userId],
    userProfileService.getUserStatistic
  );

  const { data: fingerprints, isLoading: isLoadingFps } = useSWR(
    ['getUserFingerprints', userId],
    userProfileService.getUserFingerprints
  );

  const { data: balance } = useSWR(
    ['getUserTournamentActiveBalance', userId],
    userProfileService.getUserTournamentActiveBalance
  );

  const { data: activeTickets } = useSWR(['getUserActiveTickets', userId], userProfileService.getUserActiveTickets);

  const { data: slots } = useSWR(['getUserFavoriteSlots', userId], userProfileService.getUserFavoriteSlots);

  const { data: inviter } = useSWR(user?.inviterId ? ['getUser', user.inviterId] : null, userService.getUser);

  const { data: vipLevels } = useSWR('getVipLevels', levelsService.getVipLevels);

  const { data: levels } = useSWR('getLevels', levelsService.getLevels);

  const isLoading = isLoadingUser || isLoadingStats || isLoadingFps;

  return { user, stats, fingerprints, balance, activeTickets, slots, inviter, vipLevels, levels, isLoading };
}
